import {
  ADD_CLIENT_TO_LIST,
  CLEAR_CLIENTS,
  DELETE_CLIENT_FROM_LIST,
  EDIT_CLIENT_IN_LIST,
  SET_CLIENTS,
} from '../types/clients-types';

import { clientsInitialState } from 'store/initial-states/clients-initial-state';

export const clientsReducer = (state = clientsInitialState, action) => {
  switch (action.type) {
    case SET_CLIENTS:
      // Replace the entire clients array
      return action.payload;

    case ADD_CLIENT_TO_LIST:
      // Add a new client (full client object)
      return [...state, action.payload];

    case EDIT_CLIENT_IN_LIST:
      // Edit client profile or nested data (profile, policies, etc.)
      return state.map((client) =>
        client.profile.id === action.payload.clientId
          ? {
              ...client,
              profile: {
                ...client.profile,
                ...action.payload.updatedData,
              },
            }
          : client
      );

    case DELETE_CLIENT_FROM_LIST:
      // Delete by client profile id
      return state.filter((client) => client.profile.id !== action.payload);

    case CLEAR_CLIENTS:
      // Reset to initial state
      return clientsInitialState;

    default:
      return state;
  }
};
